import { render, staticRenderFns } from "./confirmChangePaper.vue?vue&type=template&id=6236178e&scoped=true&"
import script from "./confirmChangePaper.vue?vue&type=script&lang=js&"
export * from "./confirmChangePaper.vue?vue&type=script&lang=js&"
import style0 from "./confirmChangePaper.vue?vue&type=style&index=0&id=6236178e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6236178e",
  null
  
)

export default component.exports